import { render, staticRenderFns } from "./OpdrItemsHeaderNieuw.vue?vue&type=template&id=a3da7fa4&scoped=true&"
import script from "./OpdrItemsHeaderNieuw.vue?vue&type=script&lang=js&"
export * from "./OpdrItemsHeaderNieuw.vue?vue&type=script&lang=js&"
import style0 from "./OpdrItemsHeaderNieuw.vue?vue&type=style&index=0&id=a3da7fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3da7fa4",
  null
  
)

export default component.exports